<script setup>

import WorkersSelector from "../../../components/ui-components/WorkersSelector.vue";
import WizardButton from "../../../components/ui-components/WizardButton.vue";
import Avatar from "primevue/avatar";
import Button from "primevue/button";
import MultiSelect from "primevue/multiselect";
import {watch} from "vue";
import InfoBlock from "../../../components/ui-components/InfoBlock.vue";

const model = defineModel()
const valid = defineModel('valid')

watch(model, (now) => {
    if (now.useMultipleWorkers === false) {
        valid.value = true;
    } else {
        const allServices = Object.values(now.workers).length;
        const validServices = Object.values(now.workersServices).filter((el) => el.length > 0).length
        valid.value = (validServices === allServices) && now.workers.length > 0;
    }
}, {deep: true})
</script>

<template>
<div class="flex flex-col gap-4 mb-4">
    <div class="flex gap-4" :class="{
        'flex-col': model.workers.length < 6
    }">
        <wizard-button :active="model.useMultipleWorkers === false" @select="model.useMultipleWorkers = false" wide icon="pi pi-user" :title="$t('forms.workers_single')" :description="$t('forms.workers_single_desc')"></wizard-button>
        <wizard-button :active="model.useMultipleWorkers === true" @select="model.useMultipleWorkers = true" :info="$t('forms.workers_multiple_info')" wide icon="pi pi-users" :title="$t('forms.workers_multiple')" :description="$t('forms.workers_multiple_desc')"></wizard-button>
    </div>
    <template v-if="model.useMultipleWorkers">
        <info-block class="mt-3">{{ $t('forms.workers_assign_hint') }}</info-block>
        <div class="border shadow-sm rounded-2xl bg-white dark:bg-black dark:border-neutral-700 ">

            <div class="text-sm" :class="{
            'grid grid-cols-2': model.workers.length > 8
        }">
                <div v-for="(worker, i) in model.workers" :key="worker.id" class="flex max-md:flex-wrap dark:border-neutral-700" :class="{
                'border m-1 rounded-xl': model.workers.length > 8,
                'border-b': model.workers.length <= 8
            }">
                    <div class="p-4 flex gap-3 md:w-1/4 items-center max-md:grow" :class="model.workers.length > 8 ? 'grow':''">
                        <Avatar :label="worker.initials"></Avatar>
                        <p class="font-bold">{{worker.name}}</p>
                    </div>
                    <div class="p-4 md:hidden">
                        <Button text severity="danger" @click="model.workers.splice(i, 1)" icon="pi pi-trash"></Button>
                    </div>
                    <div class="flex max-md:w-full max-md:p-4 max-md:pt-0 flex-col justify-center" :class="model.workers.length > 8 ? 'w-1/2':'grow'">
                        <MultiSelect :options="model.services" display="chip" v-model="model.workersServices[`worker-${worker.id}`]" option-label="name" :placeholder="model.workers.length <= 8 ? $t('forms.workers_add_services', { name: worker.name }) : $t('forms.workers_add_services_short')" :fluid="model.workers.length <= 8"></MultiSelect>
                    </div>
                    <div class="p-4 max-md:hidden">
                        <Button text severity="danger" @click="model.workers.splice(i, 1)" icon="pi pi-trash"></Button>
                    </div>
                </div>
            </div>
            <div class="p-3 dark:border-neutral-700" :class="{
            'border-t': model.workers.length > 8
        }">
                <workers-selector :skip-workers="model.workers.map((el) => el.id)" :workers="$page.props.workers" slim @select="(worker) => {
                model.workers.push(worker);
            }"></workers-selector>
            </div>
        </div>
    </template>
</div>
</template>

<style scoped lang="scss">

</style>
